import React, { useState } from 'react';
import axios from 'axios';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import colors from '~/assets/colors.module.scss';
import Button from '~/components/core/Atomic/Buttons/Button';
import { PlusIcon } from '~/components/icons';
import UpsertDamageAssessmentTypeDialog from '~/components/SystemConfiguration/DamageAssessmentTypes/UpsertDamageAssessmentTypeDialog';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import type { OrganizationModel } from '~/components/types/organization-types';
import type { DATypeConfigInfo } from '~/server_shared/openapi/data-contracts';

interface AddDamageAssessmentTypeButtonProps {
  damageAssessmentTypes: DATypeConfigInfo[];
  reloadDamageAssessmentTypes: () => void;
}

const AddDamageAssessmentTypeButton: React.FC<AddDamageAssessmentTypeButtonProps> = ({
  damageAssessmentTypes,
  reloadDamageAssessmentTypes,
}) => {
  const { organization } = useSysconfig() as { organization: OrganizationModel };
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleCreate = async (values: Record<string, unknown>) => {
    await axios.post(`/sysconfig/api/v1/organizations/${organization.id}/damage_assessment_type_configs`, values);
    await reloadDamageAssessmentTypes();
  };

  return (
    <>
      <Button
        className="justify-self-end text-teal-700"
        onClick={() => setIsDialogOpen(true)}
        startIcon={<PlusIcon iconColor={colors.buttonLink} size={14} />}
      >
        Add Damage Assessment Type
      </Button>
      {isDialogOpen ? (
        <UpsertDamageAssessmentTypeDialog
          damageAssessmentTypes={damageAssessmentTypes}
          onSubmit={handleCreate}
          onClose={() => setIsDialogOpen(false)}
        />
      ) : null}
    </>
  );
};

export default AddDamageAssessmentTypeButton;
